import axios from 'axios';
import { BOX_STATUS_URL, INVENTORY_URL, UPLOADED_FILES_URL } from './urls';

export const useGetAllUploadedFiles = () => {
  return async () => {
    try {
      const res = await axios.get(UPLOADED_FILES_URL, {
        headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
      });

      return res.data;
    } catch (e) {
      return {};
    }
  };
};


export const useGetBoxStatus = () => {
  return async (partId, boxNumber) => {
    try {
      const res = await axios.get(BOX_STATUS_URL(partId, boxNumber), {
        headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
      });
      return res.data;
    } catch (e) {
      return {};
    }
  };
};


export const useGetInventoryStatus = () => {
  return async () => {
    try {
      const res = await axios.get(INVENTORY_URL, {
        headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
      });
      return res.data;
    } catch (e) {
      return {};
    }
  };
};

